type NavItem = {
  solutionId?: string;
  children?: NavItem[];
  users?: string[];
};

type EnabledSolution = {
  solution_uuid: string;
};

import { useStore } from "vuex";

export const isNavItemDisabled = ({
  navItem,
  enabledSolutions,
  parentDisabled = false,
}: {
  navItem: NavItem;
  enabledSolutions: EnabledSolution[];
  parentDisabled: boolean;
  mspGlobalOrganisationId?: string | null;
}): boolean => {
  if (navItem.users) {
    const store = useStore();

    const email = store.getters["authentication/authUser"]?.email;

    if (!navItem.users.includes(email)) {
      return true;
    }
  }

  if (!navItem.solutionId) {
    return parentDisabled;
  }

  if (parentDisabled) {
    return true;
  }

  return !enabledSolutions.some(
    (solution: EnabledSolution) =>
      solution.solution_uuid === navItem.solutionId,
  );
};
